import { createApp } from 'vue'
import { createPinia } from 'pinia'
import PrimeVue from 'primevue/config'
import Aura from '@primevue/themes/aura'
import ToastService from 'primevue/toastservice'
import ConfirmationService from 'primevue/confirmationservice'
import Tooltip from 'primevue/tooltip'
import Swal from 'sweetalert2'

import { store } from './compat/vuex-store'
import BootstrapVue from './compat/bootstrap-vue'
import { auth, api } from './services'
import { eventBus } from './composables/useEventBus'
import './plugins/vee-validate'

import App from './App.vue'
import router from './router'
import i18n from './i18n'

import 'bootstrap/dist/css/bootstrap.min.css'
import 'primeicons/primeicons.css'
import 'material-icons/iconfont/material-icons.css'
import 'flag-icon-css/css/flag-icon.min.css'
import 'vue-multiselect/dist/vue-multiselect.css'
import 'vue-loading-overlay/dist/css/index.css'
import '@/assets/scss/style.scss'

declare const __APP_VERSION__: string
console.info(`Version: ${__APP_VERSION__}`)

const pinia = createPinia()
const app = createApp(App)

app.use(pinia)
app.use(store)
app.use(router)
app.use(i18n)
app.use(PrimeVue, {
  theme: {
    preset: Aura,
    options: { darkModeSelector: '.dark-mode' },
  },
})
app.use(ToastService)
app.use(ConfirmationService)
app.use(BootstrapVue)

app.directive('tooltip', Tooltip)

// Backward-compat globals — remove with compat shims
app.config.globalProperties.$auth = auth
app.config.globalProperties.$api = api
app.config.globalProperties.$swal = Swal.fire.bind(Swal)
app.config.globalProperties.$events = {
  fire: eventBus.fire.bind(eventBus),
  on: eventBus.on.bind(eventBus),
  listen: eventBus.on.bind(eventBus),
  off: eventBus.off.bind(eventBus),
  // Vue 2 $on/$off aliases used in some views
  $on: eventBus.on.bind(eventBus),
  $off: eventBus.off.bind(eventBus),
}

app.directive('capitalize', {
  updated(el: HTMLInputElement) {
    const event = new Event('input', { bubbles: true })
    el.value = el.value ? el.value.charAt(0).toUpperCase() + el.value.slice(1) : ''
    el.dispatchEvent(event)
  },
})

app.directive('lowercase', {
  updated(el: HTMLInputElement) {
    const event = new Event('input', { bubbles: true })
    el.value = el.value ? el.value.toLowerCase() : ''
    el.dispatchEvent(event)
  },
})

app.mount('#app')
